import highlightNegativeNumber from './highlight-negative-number'

const install = function(Vue) {
  Vue.directive('highlight-negative-number', highlightNegativeNumber)
}

if (window.Vue) {
  window['highlight-negative-number'] = highlightNegativeNumber
  Vue.use(install); // eslint-disable-line
}

highlightNegativeNumber.install = install
export default highlightNegativeNumber
